import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

class CategoryService {
  static getCategories(limit = 100, page = 1) {
    return ApiHelper.fetch(`${API.URL + API.CATEGORY}?pageSize=${limit}&page=${page}`)
  }

  static getCategory(id) {
    return ApiHelper.fetch(`${API.URL + API.CATEGORY}/${id}`)
  }

  static addCategory(category) {
    return ApiHelper.fetch(`${API.URL + API.CATEGORY}`, {
      method: 'POST',
      body: JSON.stringify({
        category
      })
    })
  }

  static updateCategory(category) {
    if (typeof category._id === 'undefined') {
      return this.addCategory(category)
    }

    return ApiHelper.fetch(`${API.URL + API.CATEGORY}/${category['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        category
      })
    })
  }

  static deleteCategory(id) {
    return ApiHelper.fetch(`${API.URL + API.CATEGORY}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default CategoryService
